import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormArray, FormControl, FormGroup, FormGroupDirective, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
import { StudentRegister } from '../../classes/student-register';
import { AppService } from '../../services/app.service';
import { SnackBarService } from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
import { validateDate } from '../../validators/date.validator';
import { validateMatch } from '../../validators/match.validator';
import { validateNumber } from '../../validators/number.validator';
import { validatePassword } from '../../validators/password.validator';
import { ErrorService } from '../../services/error.service';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    imports: [
        MatCardModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        RouterModule,
        MatFormFieldModule
    ]
})
export class RegisterComponent implements OnInit {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly appSvc = inject(AppService);
    protected readonly router = inject(Router);
    protected readonly snackBarSvc = inject(SnackBarService);
    protected readonly errorSvc = inject(ErrorService);
    registerForm: FormGroup;
    loading: boolean = true;
    formSubmitted: boolean = false;
    matcher: ErrorStateMatcher;
    passwordComponent: FormArray;
    createdUsername: string;
    submitted: boolean = false;

    ngOnInit() {
        this.createForm();
    }

    createForm() {
        this.matcher = new PasswordMatch();

        this.registerForm = new FormGroup({
            StudentID: new FormControl('', [Validators.required, Validators.minLength(10), validateNumber]),
            Email: new FormControl('', [Validators.required, Validators.email]),
            DateOfBirth: new FormControl('', [Validators.required, validateDate]),
            PasswordArray: new FormArray([])
        });

        this.passwordComponent = this.registerForm.get('PasswordArray') as FormArray;
        let fc1 = new FormControl('', [Validators.required, Validators.minLength(10)]);
        fc1.addValidators(validatePassword);
        let fc2 = new FormControl('', Validators.required);
        this.passwordComponent.push(fc1);
        this.passwordComponent.push(fc2);
        this.passwordComponent.addValidators(validateMatch);

        this.loading = false;
    }

    submit(form: FormGroup) {
        if (form.invalid) {
            this.formSubmitted = true;
            return;
        }

        this.submitted = true;

        let dto: StudentRegister = {
            Email: form.value.Email,
            DateOfBirth: form.value.DateOfBirth,
            Password: this.passwordComponent.at(0).value,
            StudentID: form.value.StudentID
        };


        this.appSvc.RegisterStudent(dto).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: res => {
                this.snackBarSvc.success('Account Registered', 5000);
                this.createdUsername = res.stringValue;
                this.formSubmitted = false;
            }, error: error => {
                this.errorSvc.HandleServiceError(error);
                this.submitted = false;

                if (error.error === 'Student not eligible to apply') {
                    this.router.navigate(['instructions']);
                }
            }
        });
    }
}

export class PasswordMatch implements ErrorStateMatcher {
    //ErrorStateMatcher is necessary because match validator does not mark form control as invalid
    //form will only show error if form control is invalid
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        let array = control?.parent as FormArray;

        if (control?.dirty || form.submitted) {
            return array.at(0).value !== array.at(1).value;
        }

        return false;
    }
}